import { Component, Inject, OnInit, Optional, Pipe } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { EMRService } from 'app/EMR/EMR.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-dynamic-help-list',
  templateUrl: './dynamic-help-list.component.html',
  styleUrls: ['./dynamic-help-list.component.scss']
})

export class DynamicHelpListComponent implements OnInit {
  destroydyna$: Subject<boolean> = new Subject<boolean>();
  private rowClicked: any;
  private searchValue02: any;
  private helpDescription: string = '';
  private presRemarksArray: any = [];
  private nextreviewrocesses:any=[];
  
  constructor(private authService:AuthService,private emrservice: EMRService, private dashboardService: DashboardService, private dialogRef: MatDialogRef<DynamicHelpListComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any,) {
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.rowClicked = -1;
    this.nextreviewrocesses=[];
    this.presRemarksArray = [];
    this.helpDescription='';
    this.getDyanamicHelplist(this.data.parametertype);
  }
  ngOnDestroy() {
    this.destroydyna$.next(true);
    this.destroydyna$.unsubscribe();
    this.rowClicked=null;
    this.nextreviewrocesses=null;
    this.presRemarksArray=null;
    this.helpDescription=null;
   
  }
  getDyanamicHelplist(param: any) {
    this.emrservice.GetPopUpHelpGeneral(param).pipe(takeUntil(this.destroydyna$)).subscribe((item: any) => {
      this.presRemarksArray = item.filter(x => x.isActive == true);
    },err =>{
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } 
      else if(err.error.statusCode == 422){
        this.dashboardService.openSnackBar(err.error.message,"OK");
      }
      else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    });

  }
  // keyupSearching(value:any){

  //   if(value !='' && value !=null && value !=undefined){
  //     this.presRemarksArray= this.presRemarksArray ? this.presRemarksArray.filter(item => item.helpDescription.search(new RegExp(value, 'i')) > -1) : [];
  //   }else{
  //     this.ngOnInit();
  //   }
  // }
  rowdata: any = {};
  changeTableRowColor(row: any, idx: any) {

    if (this.rowClicked === idx) {

      this.rowClicked = -1;
      this.rowdata = {};
      this.helpDescription = '';
    }
    else {

      this.rowdata = row;
      this.rowClicked = idx;
      this.helpDescription = row.helpDescription;
    }

  }
  //delete pop up open 
  Cancelpopup(type) {
    if (type == 1) {
      document.getElementById("dynamicheliplitsModal").style.display = "Block";
    } else {
      this.helpDescription = '';
      document.getElementById("dynamicheliplitsModal").style.display = "None";
    }
  }
  onReviewGrid(desc: any) {

    if(this.nextreviewrocesses.length >0){
       var newchar ='';
      this.nextreviewrocesses.forEach(item=>{
        newchar = item + ',' + newchar;
      })
      this.dialogRef.close(newchar);
    
    }else{
      this.dialogRef.close(desc);
    }
    //this.dialogRef.close(desc);
  }
  
  reprocessHomeProcesses(exe, event: any) {
    if (event.checked) {
      this.nextreviewrocesses.push(exe)
    } else {
      var index = this.nextreviewrocesses.indexOf(exe)
      if (index > -1) {
        this.nextreviewrocesses.splice(index, 1);
      }
    }
  }
  
  doctorpopup() {
    this.dialogRef.close(0);
  }
  letterCaseupdate(type) {
    if (this.presRemarksArray.length > 0) {
      if (type == 1) {
        this.presRemarksArray.forEach(element => {
          var payload = {
            "DynamicHelpList": {
              "pK_TranId": element.pK_TranId,
              "helpType": this.data.parametertype,
              "sequenceSetting": " ",
              "seqNo": element.seqNo,
              "helpDescription": element.helpDescription.toUpperCase(),
              "isActive": true,
              "pK_SynchId": null,
              "isEdit": true,
              "isDelete": false
            }
          }
           this.emrservice.InsertDynamicHelpList(payload).pipe(takeUntil(this.destroydyna$)).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.ngOnInit();

            } else {

              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          },
            err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              } 
              else if(err.error.statusCode == 422){
                this.dashboardService.openSnackBar(err.error.message,"OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            }
          );
        });

      } else if (type == 2) {
        this.presRemarksArray.forEach(element => {
          var payload = {
            "DynamicHelpList": {
              "pK_TranId": element.pK_TranId,
              "helpType": this.data.parametertype,
              "sequenceSetting": " ",
              "seqNo": element.seqNo,
              "helpDescription": this.titleCase(element.helpDescription),
              "isActive": true,
              "pK_SynchId": null,
              "isEdit": true,
              "isDelete": false
            }
          }
          this.emrservice.InsertDynamicHelpList(payload).pipe(takeUntil(this.destroydyna$)).subscribe(data => {
            if (data['statusCode'] == 1) {
              this.ngOnInit();

            } else {

              this.dashboardService.openSnackBar("API Failed", "OK");
            }
          },
            err => {
              if (err.status == 403) {
                this.dashboardService.openSnackBar("You Don't have Permission", "OK");
              } 
              else if(err.error.statusCode == 422){
                this.dashboardService.openSnackBar(err.error.message,"OK");
              }
              else {
                this.dashboardService.openSnackBar("API Failed", "OK");
              }
            }
          );
        });
      }

    } else {
      this.dashboardService.openSnackBar("No Data Found", "OK");
    }
  }
  titleCase(str) {
    return str.toLowerCase().replace(/\b\w/g, s => s.toUpperCase());
  }
  AddhelpListdata() {
   
    if (this.data.parametertype != '' && this.helpDescription != '') {
     
        let seqno = this.presRemarksArray.length + 1;
        let payload = {
          "DynamicHelpList": {
            "pK_TranId": 0,
            "helpType": this.data.parametertype,
            "sequenceSetting": " ",
            "seqNo": seqno,
            "helpDescription": this.helpDescription,
            "isActive": true,
            "pK_SynchId": null,
            "isEdit": false,
            "isDelete": false
          }
        }
       this.emrservice.InsertDynamicHelpList(payload).pipe(takeUntil(this.destroydyna$)).subscribe(data => {
          if (data['statusCode'] == 1) {
            this.ngOnInit();
            this.helpDescription = '';
            document.getElementById("dynamicheliplitsModal").style.display = "None";
            this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          }else if( data['statusCode'] == 10) {
            this.dashboardService.openSnackBar("Already Exists Description", "OK");
          }else if( data['statusCode'] == 7) {
            this.dashboardService.openSnackBar("API Failed", "OK");
          } else {
  
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        },
          err => {  
            if (err.status == 403) {
              this.dashboardService.openSnackBar("You Don't have Permission", "OK");
            } 
            else if(err.error.statusCode == 422){
              this.dashboardService.openSnackBar(err.error.message,"OK");
            }
            else {
              this.dashboardService.openSnackBar("API Failed", "OK");
            }
  
          }
        );
     
     
    } else {
      this.dashboardService.openSnackBar("Plz Enter Description", "OK");
    }
  }
  //update pop up
  optypenumber: number = 0;
  closePopup(type, optype) {
    if (type == 1) {
      this.optypenumber = optype;
      document.getElementById("updatehelplistModal").style.display = "Block";
    } else {
      this.optypenumber = 0;
      this.helpDescription = '';
      this.rowdata = {};
      document.getElementById("updatehelplistModal").style.display = "None";
    }
  }
  // update and deActivate code 
  modifyhelpListdata() {
  
    if (this.data.parametertype != '' && this.helpDescription != '' && Object.keys(this.rowdata).length >= 0 && this.optypenumber > 0) {
    
      
      if (this.optypenumber == 1) {
      
        var payload = {
          "DynamicHelpList": {
            "pK_TranId": this.rowdata.pK_TranId,
            "helpType": this.data.parametertype,
            "sequenceSetting": " ",
            "seqNo": this.rowdata.seqNo,
            "helpDescription": this.helpDescription,
            "isActive": true,
            "pK_SynchId": null,
            "isEdit": true,
            "isDelete": false
          }
        }
     
      } else if (this.optypenumber == 2) {
        var payload = {
          "DynamicHelpList": {
            "pK_TranId": this.rowdata.pK_TranId,
            "helpType": this.data.parametertype,
            "sequenceSetting": " ",
            "seqNo": this.rowdata.seqNo,
            "helpDescription": this.helpDescription,
            "isActive": false,
            "pK_SynchId": null,
            "isEdit": true,
            "isDelete": true
          }
        }
      }

     this.emrservice.InsertDynamicHelpList(payload).pipe(takeUntil(this.destroydyna$)).subscribe(data => {
        if (data['statusCode'] == 1) {
          this.ngOnInit();
          this.helpDescription = '';
          this.rowdata = {};
          if (this.optypenumber == 1) {
            this.dashboardService.openSnackBar("Record Updated Successfully", "OK");
          } else {
            this.dashboardService.openSnackBar("Record De-Active Successfully", "OK");
          }
          this.optypenumber = 0;
          document.getElementById("updatehelplistModal").style.display = "None";

        
        }else if( data['statusCode'] == 10) {
          this.dashboardService.openSnackBar("Already Exists Description", "OK");
        }else if( data['statusCode'] == 7) {
          this.dashboardService.openSnackBar("API Failed", "OK");
        } else {

          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      },
        err => {
          if (err.status == 403) {
            this.dashboardService.openSnackBar("You Don't have Permission", "OK");
          } 
          else if(err.error.statusCode == 422){
            this.dashboardService.openSnackBar(err.error.message,"OK");
          }
          else {
            this.dashboardService.openSnackBar("API Failed", "OK");
          }
        }
      );
    
    } else {
      this.dashboardService.openSnackBar("Plz Enter Description", "OK");
    }
  }
}
